// eslint-disable-next-line import/prefer-default-export
export enum LogoId {
  LIBERIS_BLACK = 'liberisLogoBlack',
  LIBERIS_WHITE = 'liberisLogoWhite',
  WORLDPAY = 'worldpayLogo',
  WORLDPAY_BLACK = 'worldpayLogoBlack',
  WORLDPAY_TOOLTIP_1 = 'worldpayTooltip1',
  WORLDPAY_TOOLTIP_2 = 'worldpayTooltip2',
  ELAVON_WHITE = 'elavonLogoWhite',
  ELAVON_BLACK = 'elavonLogoBlack',
  ELAVON_WHITE_MOBILE = 'elavonLogoWhiteMobile',
  ELAVON_BLACK_MOBILE = 'elavonLogoBlackMobile',
  BARCLAYCARD_WHITE = 'barclaycardLogoWhite',
  BARCLAYCARD_WHITE_MOBILE = 'barclaycardLogoWhiteMobile',
  BARCLAYCARD_BLACK = 'barclaycardLogoBlack',
  BARCLAYCARD_BLACK_CENTERED = 'barclaycardLogoBlackCentered',
  KLARNA = 'klarnaLogoBlack',
  NETS_LOGO_WHITE = 'netsLogoWhite',
  NETS_SWEDEN = 'netsSweden',
  NETS_DENMARK = 'netsDenmark',
  NETS_FINLAND = 'netsFinland',
  GLOBAL_PAYMENTS_BLACK = 'globalPaymentsBlack',
  GLOBAL_PAYMENTS_WHITE = 'globalPaymentsWhite',
  GLOBAL_PAYMENTS_BLACK_VERTICAL = 'globalPaymentsBlackVertical',
  BROKER_PARTNER_BLACK = 'liberisLogoBlack',
  BROKER_PARTNER_WHITE = 'liberisLogoWhite',
  CLOVER = 'cloverLogo',
  CLOVER_BLACK = 'cloverLogoBlack',
}
